import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable } from '../../../web/src/components/data-table.jsx';
import { translateColumns } from '../../../web/src/locale/translate-columns.js';
import { CURRENCY_COLUMNS } from './../../../shared-site-web/screens/currency-table.js';
import { useSiteLang } from '../layout/use-site-lang.js';
import { getMockCurrencies } from './mock-data/mock-data.js';
import { inertActions } from './mock-table.jsx';

/**
 * The currency list, rendered with the app's real DataTable and column
 * definitions. Defaults to the locale's custom-currencies set (miles, points,
 * status miles); pass `currencies` for a different set (e.g. auto rates).
 * @param {{ currencies?: Array<Record<string, unknown>> }} [props]
 * @returns {JSX.Element}
 */
export function CurrenciesCard({ currencies } = {}) {
	const { t } = useTranslation();
	const lang = useSiteLang();
	const rows = useMemo(() => currencies ?? getMockCurrencies(lang), [currencies, lang]);
	return (
		<DataTable
			columns={translateColumns(CURRENCY_COLUMNS, t)}
			rows={rows}
			title={t('page.title.currencies')}
			emptyMessage=""
			renderActions={inertActions(t)}
		/>
	);
}
